import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import SetQuestionScoreById from 'api/design/v1.design.Synthesis';
import QuestionFile from 'components/AliyunOSS/phoneQuestionFileNew.vue';
export default {
  components: {
    QuestionFile: QuestionFile
  },
  props: {
    isBook: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: null
    },
    childQuestionList: {
      default: function _default() {
        return [];
      }
    },
    childAnswerList: {
      default: function _default() {
        return [];
      }
    },
    IsList: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsTitle: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    var _this = this;

    this.jsonData.Id = this.data.Id;
    var answerIndex = 0;
    this.childQuestionList.forEach(function (element, index) {
      if (_this.childAnswerList[answerIndex] && _this.childAnswerList[answerIndex].Id === element.Id) {
        _this.SubAnswers.push(_this.childAnswerList[answerIndex]);

        answerIndex += 1;
      } else {
        if (element.QuestionType === 2) {
          _this.SubAnswers.push({
            Id: element.Id,
            ParentQuestionId: element.ParentQuestionId,
            Answers: []
          });
        } else {
          _this.SubAnswers.push({
            Id: element.Id,
            ParentQuestionId: element.ParentQuestionId,
            Answers: ['']
          });
        }
      }
    }); // 题目附件

    this.filesList = this.data.stemFiles;
  },
  data: function data() {
    return {
      urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
      // 题干附件
      fileList: [],
      fileIds: [],
      // 附件Id
      filesList: [],
      anaShow: true,
      showThisAnswer: true,
      selects: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V'],
      numstr: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      jsonData: {
        Id: '',
        Answers: []
      },
      SubAnswers: []
    };
  },
  methods: {
    upDown: function upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    },
    // 添加正确答案
    addCheckValue: function addCheckValue() {
      this.CheckValues = this.check;
    },
    changeAnswers: function changeAnswers(index) {
      this.$emit('getAnswer', {
        jsonData: this.jsonData,
        SubAnswers: this.SubAnswers[index]
      });
    }
  }
};